const errorMessages = {
  format: 'Insira um formato válido',
  empty: 'Preencha esta informação',
  mandatory: 'Campo obrigatório! Não esqueça de preenchê-lo.',
  characters: 'O campo precisa de 2 caracteres ou mais',
  document: {
    same(secondaryParticipant) {
      return `Insira um documento diferente do ${secondaryParticipant}`;
    }
  }
};

export {
  errorMessages,
}
